module.exports = __webpack_public_path__ + "images/Popup_960x720_v23.png";